import getExtendedPropertyValue from './getExtendedPropertyValue';
import { isString } from 'util';
var DOCUMENT_ID_TAG = '0x6815';
export default function getDocumentId(item) {
    var value = getExtendedPropertyValue(item, DOCUMENT_ID_TAG);
    return isString(value) ? parseInt(value) : 0;
}
//# sourceMappingURL=getDocumentId.js.map